export default __webpack_public_path__ + "locales/en/ConnectDialog.json?hash=290aa305a2942affc85c9cb8dfd965e5";